angular.module('homebot.directives')

  .directive('toggleSubscribe', ['DataService', '$timeout', function(DataService, $timeout){
    return {
      controllerAs: 'subscribeCtrl',
      bindToController: {
        onSuccess: '&',
        user: '=',
      },
      restrict: 'A',
      scope: {},
      templateUrl: function(el, attrs){
        return attrs.templateUrl || '/homes/templates/partials/toggle-subscribe.html';
      },
      controller: function(){
        var ctrl = this;

        function success(user){
          // changed signifies that it's not a fresh page load
          // and the messaging should be different
          ctrl.changed = true;

          ctrl.user = user;

          if(ctrl.onSuccess)
            ctrl.onSuccess();

          ctrl.loading = false;
        };

        function error(err){
          ctrl.error = err;
          ctrl.loading = false;
        };

        ctrl.toggle = function(){
          var endpoint = ctrl.user.digestEmailUnsubscribed ? 'subscribe' : 'unsubscribe';
          ctrl.loading = true;
          ctrl.error = null;

          DataService.emailSubscribe[endpoint](ctrl.user.id)
            .then(success)
            .catch(error);

          return false;
        };

      }
    }
  }]);
